 let items = document.querySelector(".header__inline-menu").querySelectorAll("details"); 
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      
      document.body.classList.add('white-bg-black-text-header');
      
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      
      document.body.classList.remove('white-bg-black-text-header');

    });
  });
   
  });


 let items2 = document.querySelector(".header__icons .header__inline-menu").querySelectorAll("details"); 
  items2.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      
      document.body.classList.add('white-bg-black-text-header');
      
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      
      document.body.classList.remove('white-bg-black-text-header');

    });
  });
  
  });